import { render, staticRenderFns } from "./homeCarousel.vue?vue&type=template&id=dd6b58a2"
import script from "./homeCarousel.vue?vue&type=script&lang=js"
export * from "./homeCarousel.vue?vue&type=script&lang=js"
import style0 from "./homeCarousel.vue?vue&type=style&index=0&id=dd6b58a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports